<script setup lang="ts">
import {
  showVIPDialogue,
  showPayCodeDialogue,
} from "@/components/Dialogues/useData/useDialogues";
import qs from "qs";

import { mobilePayUrl, wxMobilePayUrl } from "@/config/apiDomain";
import { openAgreement } from "@/components/Dialogues/useData/login";
import { isMobile } from "@/data/pubilc";
import { isCompactMode } from "@/data/pubilc";
import { computed, onMounted, reactive, ref, watch, watchEffect } from "vue";
import {
  requestProduct,
  productInfo,
  productItem,
  productIndex,
  requestPayInfo,
  payInfo,
  startPoll,
  stopPoll,
} from "./useData/usePayData";

import { ElMessage } from "element-plus";
import { getStorage, setStorage } from "@/utils/storage";

const dialogueWidth = computed(() => {
  return isCompactMode.value ? "100%" : "800px";
});

watch(
  showVIPDialogue,
  (nVal) => {
    if (nVal) {
      requestProduct();
    } else {
      // if (timerFlag > 0) {
      //   clearInterval(timerFlag);
      //   timerFlag = -1;
      // }
    }
  },
  {
    immediate: true,
  }
);

watch(productInfo, (newVal) => {
  if (newVal.length > 0) {
    startTime();
  }
});

const isPermanentVer = (index: number) => {
  const item = productInfo[index];
  const plan_name = item.plan_name;

  return plan_name === "终身会员";
};

const displayPriceTag = (index: number) => {
  const item = productInfo[index];
  return item.price;

  // const plan_name = item.plan_name;
  // if (plan_name === "终身会员") {
  //   return item.price;
  // }
  //
  // if (plan_name.includes("半年")) {
  //   return (item.price / 6).toFixed(1);
  // }
  //
  // if (plan_name.includes("年度")) {
  //   return (item.price / 12).toFixed(1);
  // }
  //
  // if (plan_name.includes("月")) {
  //   return item.price;
  // }
};

// 判断是否微信环境
const isWeiXin = () => {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (
    ua.match(/MicroMessenger/i) == "micromessenger" &&
    ua.match(/wxwork/i) != "wxwork"
  ) {
    return true;
  } else {
    return false;
  }
};

const mobilePay = (data: any) => {
  let query = {
    soft_id: getStorage("soft_id"),
    ekey: getStorage("ekey"),
    source: getStorage("source"),
  };
  setStorage("isPay", JSON.stringify({ orderId: data.id }));
  if (isWeiXin()) {
    window.location.href = `${wxMobilePayUrl}/api/show-order?order_id=${
      data.id
    }&${qs.stringify(query)}`;
    return;
  }
  window.location.href = `${mobilePayUrl}/pay/pay.html?order_id=${
    data.id
  }&skip=order&${qs.stringify(query)}`;
};

const pay = async () => {
  //

  try {
    const payData = await requestPayInfo();

    if (isCompactMode.value) {
      mobilePay(payData);
      startPoll();

      return;
    }

    showPayCodeDialogue.value = true;
    startPoll();
  } catch (error: any) {
    const msg = error.msg || "获取商品信息失败";

    ElMessage.error(msg);

    console.log(error);
  }
};

let timerFlag = -1;
const timerCount = ref(3600);

const startTime = () => {
  if (timerFlag > 0) {
    clearInterval(timerFlag);
    timerFlag = -1;
    timerCount.value = 3600;
  }

  timerFlag = setInterval(() => {
    timerCount.value = timerCount.value - 1;
    if (timerCount.value === 0) {
      clearInterval(timerFlag);
      timerFlag = -1;
      timerCount.value = 3600;
    }
  }, 1000);
};

const displayTime = computed(() => {
  const time = timerCount.value;
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
});

const didClose = () => {
  if (timerFlag > 0) {
    clearInterval(timerFlag);
    timerFlag = -1;
    timerCount.value = 3600;
  }

  showVIPDialogue.value = false;
};

const payCodeClose = (done) => {
  //
  console.log("payCodeClose");
  stopPoll();
  done();
};

const _openAgreement = () => {
  //
  openAgreement();
};
</script>

<template>
  <el-dialog
    v-model="showVIPDialogue"
    :width="dialogueWidth"
    class="custom-dialog"
    align-center
    :before-close="didClose"
    :show-close="false"
    :destroy-on-close="true"
    :style="{
      '--el-dialog-bg-color': 'none',
      '--el-dialog-padding-primary': '0',
      '--el-dialog-box-shadow': 'none',
    }"
    :close-on-click-modal="false"
  >
    <el-dialog
      :before-close="payCodeClose"
      v-model="showPayCodeDialogue"
      width="300"
      append-to-body
      align-center
      :style="{
        '--el-dialog-padding-primary': '10',
        '--el-dialog-box-shadow': 'none',
      }"
    >
      <div class="pay-code-base">
        <div class="code-base">
          <el-image
            style="width: 100%; height: 100%"
            :src="payInfo.url"
            fit="cover"
          />
          <div class="center-logo">
            <img
              style="width: 26px; height: 26px"
              src="@/assets/wechat.png"
              fit="cover"
            />
          </div>
        </div>
        <span class="bottom-info">
          推荐使用微信扫码支付
          <span class="sub">
            支付即视为您同意<text class="btn" @click="_openAgreement"
              >《会员协议》</text
            >
          </span>
        </span>
      </div>
    </el-dialog>
    <div class="super-box">
      <div
        class="custom-body"
        :class="{
          'custom-body-mobile': isCompactMode,
        }"
      >
        <div class="header-bar">
          <div class="close" @click="didClose">
            <el-icon :size="20" :color="`white`"><Close /></el-icon>
          </div>
        </div>
        <div class="product-part">
          <div class="product-info">
            <div class="left">
              <img src="@/assets/flash.png" class="icon" />
              <div class="title-part">
                <div class="title">DeepSeek-R1 671B满血版（无限量使用）</div>
                <div class="sub-title">
                  API高速专线·永不卡顿·永不崩溃·极速响应
                </div>
              </div>
            </div>
            <div class="right">
              <div class="timer-info">
                <div class="title">即将涨价30%</div>
                <div class="timer">{{ displayTime }}</div>
              </div>
            </div>
          </div>
          <div class="person-info">
            <div class="h-div"></div>
            <div class="title">已经有136886个用户开通会员</div>
            <div class="h-div"></div>
          </div>

          <div class="product-display">
            <div
              class="item"
              v-for="(item, i) in productInfo"
              :key="i"
              :class="{ 'item-selected': i == productIndex }"
              @click="productIndex = i"
            >
              <div class="tag" v-if="isPermanentVer(i)">最多人选</div>
              <div class="name">
                {{ item.plan_name }}
              </div>
              <div class="price">
                <div class="sub">¥</div>
                <div class="main">
                  {{ displayPriceTag(i) }}
                </div>
              </div>
            </div>
          </div>
          <div class="bottom-bar" v-if="productInfo.length">
            <div class="pay-btn" @click="pay">
              {{ isCompactMode ? "前往支付" : "立即支付" }}
              <div class="tag">¥{{ productItem.price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.custom-dialog {
  :deep(.el-dialog__header) {
    display: none !important;
  }
  .el-dialog__header {
    display: none !important;
  }

  .super-box {
    width: 100%;
    height: auto;
    background: none;
    display: flex;
    justify-content: center;
  }

  .custom-body {
    width: 100%;
    height: 671px;
    position: relative;
    background: url(@/assets/pay.png) no-repeat;
    box-sizing: border-box;
    //.back-img {
    //  position: absolute;
    //  top: 0;
    //  left: 0;
    //  width: 800px;
    //  height: 671px;
    //}
    padding: 30px;
    padding-right: 130px;

    .header-bar {
      display: flex;
      flex-direction: row-reverse;

      .close {
        padding: 4px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          background: #dbeafe33;
        }
      }
    }

    .product-part {
      width: 100%;
      height: 400px;
      margin-top: 180px;
      padding-top: 12px;

      .product-info {
        padding-left: 12px;
        padding-right: 0px;

        width: 100%;
        display: flex;
        align-items: center;
        height: 56px;
        justify-content: space-between;

        .left {
          display: flex;
          align-items: center;
          height: 56px;
        }
        .icon {
          width: 56px;
          height: 56px;
        }

        .title-part {
          margin-left: 10px;
          display: flex;
          align-items: start;
          flex-direction: column;
          //justify-content: space-between;
          gap: 15px;
          color: white;
          .title {
            font-size: 16px;
            font-weight: bold;
          }

          .sub-title {
            font-size: 14px;
          }
        }

        .right {
          width: 217px;
          height: 62px;
          background: url("@/assets/timer-bg.png") no-repeat;
          .timer-info {
            width: 100%;
            height: 100%;
            color: white;
            display: flex;
            align-items: start;
            flex-direction: column;
            justify-content: center;
            padding-left: 100px;
            padding-top: 2px;
            .title {
              font-size: 16px;
              font-weight: bold;
            }
            .timer {
              font-size: 14px;
            }
          }
        }
      }
      .person-info {
        margin-top: 40px;
        padding-left: 12px;
        padding-right: 12px;
        color: white;
        display: flex;
        align-items: center;
        gap: 8px;
        .h-div {
          height: 1px;
          flex: 1;
          background-color: white;
        }

        .title {
          font-size: 14px;
        }
      }

      .product-display {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;
        padding-left: 12px;
        padding-right: 12px;
        gap: 20px;
        .item {
          position: relative;
          cursor: pointer;
          width: 100%;
          height: 128px;
          background-color: white;
          padding: 16px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          font-weight: bold;
          flex-direction: column;
          border: 4px solid white;

          .tag {
            position: absolute;
            left: -4px;
            width: 64px;
            height: 26px;
            top: -15px;
            border-radius: 13px 13px 13px 0;
            background: linear-gradient(0, #ff1366, #8244ff);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 12px;
            z-index: 2;
          }

          .name {
            font-size: 14px;
            color: black;
          }

          .price {
            color: red;
            display: flex;
            align-items: center;
            justify-content: center;

            .sub {
              font-size: 16px;
            }
            .main {
              font-size: 24px;
            }
          }
        }

        .item-selected {
          border: 4px solid rgb(255 62 155);
        }
      }

      .bottom-bar {
        margin-top: 30px;
        display: flex;
        width: 100%;
        height: 56px;

        align-items: center;
        justify-content: center;
        .pay-btn {
          border-radius: 28px;
          width: 490px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(0, #892fff, #2a63ff);
          color: white;
          cursor: pointer;
          font-weight: 700;
          gap: 8px;
          .pay-way {
            font-size: 18px;
          }
          .tag {
            font-size: 12px;
          }

          &:hover {
            background: linear-gradient(0, #892fff99, #2a63ff99);
          }
        }
      }
    }
  }

  .custom-body-mobile {
    border-radius: 16px;
    padding: 10px;
    padding-bottom: 20px;

    width: calc(100% - 20px);
    background: url("@/assets/pay-mobile.jpg");
    background-size: 100% auto; /* 将图片宽度压缩到 1000px，高度按比例缩放 */
    background-position: top; /* 图片从顶部开始显示 */
    background-repeat: no-repeat; /* 防止图片重复 */
    background-color: #fff9ee;
    height: auto;

    max-width: 500px;

    .header-bar {
      display: flex;
      flex-direction: row-reverse;

      .close {
        padding: 4px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          background: #dbeafe33;
        }
      }
    }

    .product-part {
      width: 100%;
      height: auto;
      margin-top: 120px;
      padding-top: 12px;

      .product-info {
        padding-left: 12px;
        padding-right: 0px;

        width: 100%;
        display: flex;
        align-items: center;
        height: 56px;
        justify-content: center !important;

        .left {
          display: flex;
          align-items: center;
          height: 56px;
        }
        .icon {
          width: 56px;
          height: 56px;
          display: none;
        }

        .title-part {
          margin-left: 10px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          gap: 10px;
          color: #ce5c03 !important;
          .title {
            font-size: 16px;
            font-weight: bold;
          }

          .sub-title {
            font-size: 14px;
          }
        }

        .right {
          display: none;
          width: 217px;
          height: 62px;
          background: url("@/assets/timer-bg.png") no-repeat;
          .timer-info {
            width: 100%;
            height: 100%;
            color: white;
            display: flex;
            align-items: start;
            flex-direction: column;
            justify-content: center;
            padding-left: 100px;
            padding-top: 2px;
            .title {
              font-size: 16px;
              font-weight: bold;
            }
            .timer {
              font-size: 14px;
            }
          }
        }
      }
      .person-info {
        margin-top: 20px;
        padding-left: 12px;
        padding-right: 12px;
        color: #ce5c03 !important;
        display: flex;
        align-items: center;
        gap: 8px;
        .h-div {
          height: 1px;
          flex: 1;
          background-color: #ce5c03;
        }

        .title {
          font-size: 14px;
        }
      }

      .product-display {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        padding-left: 12px;
        padding-right: 12px;
        gap: 10px;
        flex-wrap: wrap;
        .item {
          position: relative;
          cursor: pointer;
          width: calc(50% - 5px);
          height: 128px;
          background: white;
          padding: 16px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          font-weight: bold;
          flex-direction: column;
          border: 2px solid rgb(234 216 194);

          .tag {
            position: absolute;
            left: -4px;
            width: 64px;
            height: 26px;
            top: -15px;
            border-radius: 13px 13px 13px 0;
            background: linear-gradient(
              270deg,
              rgb(255, 131, 68) 0%,
              rgb(242, 34, 1) 100%
            );
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 12px;
            z-index: 2;
          }

          .name {
            font-size: 14px;
            color: rgb(90 58 34);
          }

          .price {
            color: rgb(90 58 34);
            display: flex;
            align-items: center;
            justify-content: center;

            .sub {
              font-size: 16px;
            }
            .main {
              font-size: 24px;
            }
          }
        }

        .item-selected {
          background: linear-gradient(
            160deg,
            rgb(255, 248, 244) 5%,
            rgb(255, 232, 213) 100%
          );
          border: 2px solid #ffc064;
        }
      }

      .bottom-bar {
        margin-top: 30px;
        display: flex;
        width: 100%;
        height: 45px;

        align-items: center;
        justify-content: center;
        .pay-btn {
          border-radius: 8px;
          width: 300px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(to left, #ffe1cb, #ffb980);
          color: rgb(90 58 34);
          cursor: pointer;
          font-weight: 700;
          gap: 8px;
          .pay-way {
            font-size: 18px;
          }
          .tag {
            font-size: 12px;
          }

          &:hover {
            background: linear-gradient(to right, #ffe1cb, #ffb980);
          }
        }
      }
    }
  }

  .mobile-mode {
    background: none;
  }
}

.custom-dialog .el-dialog__header {
  display: none;
}

.pay-code-base {
  width: 300px;
  height: 350px;
  display: flex;
  align-items: center;
  padding: 30px;
  flex-direction: column;
  gap: 10px;
  .code-base {
    margin-top: 10px;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 10px;
    border: 2px solid #4d6bfe;
    padding: 4px;
    .img {
      width: 100%;
      height: 100%;
    }
    position: relative;

    .center-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      border-radius: 4px;
      left: calc(50% - 14px);
      top: calc(50% - 14px);
      width: 28px;
      background-color: white;
      height: 28px;
    }
  }

  .bottom-info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
    gap: 4px;
    .sub {
      color: #999999;

      .btn {
        cursor: pointer;
      }
    }
  }
}
</style>
